export default __webpack_public_path__ + "static/char-thumb-sp01-4206669d0f115531b9ed68fba71a8c21.png";